import { apiService } from './api';
import { 
  CreatePlatformAccountRequest, 
  UpdatePlatformAccountRequest, 
  PlatformAccountsResponse, 
  PlatformAccountResponse 
} from '@/types/platformAccount';

export class PlatformAccountService {
  /**
   * Get platform accounts for a customer
   */
  async getCustomerPlatformAccounts(customerId: string, params?: { page?: number; limit?: number; platformId?: number }): Promise<PlatformAccountsResponse> {
    return apiService.get<PlatformAccountsResponse>(`/platforms/customer/${customerId}/accounts`, params);
  }

  /**
   * Get a single platform account by ID
   */
  async getPlatformAccount(accountId: string): Promise<PlatformAccountResponse> {
    return apiService.get<PlatformAccountResponse>(`/platforms/accounts/${accountId}`);
  }

  /**
   * Create a new platform account
   */
  async createPlatformAccount(accountData: CreatePlatformAccountRequest): Promise<PlatformAccountResponse> {
    return apiService.post<PlatformAccountResponse>('/platforms/accounts', accountData);
  }

  /**
   * Update an existing platform account
   */
  async updatePlatformAccount(id: string, accountData: UpdatePlatformAccountRequest): Promise<PlatformAccountResponse> {
    return apiService.put<PlatformAccountResponse>(`/platforms/accounts/${id}`, accountData);
  }

  /**
   * Delete a platform account (only if no associated data)
   */
  async deletePlatformAccount(id: string): Promise<{ success: true; message: string }> {
    return apiService.delete<{ success: true; message: string }>(`/platforms/accounts/${id}`);
  }

  /**
   * Get platform stats for a customer
   */
  async getCustomerPlatformStats(customerId: string): Promise<any> {
    return apiService.get<any>(`/platforms/customer/${customerId}/stats`);
  }

  /**
   * Get customer accounts by platform
   */
  async getCustomerAccountsByPlatform(customerId: string, platformId: number): Promise<any> {
    return apiService.get<any>(`/platforms/customer/${customerId}/accounts/platform/${platformId}`);
  }
}

export const platformAccountService = new PlatformAccountService();